<template>
  <div class="history-page">
    <!-- 顶部标题栏 -->
    <div class="history-header">
      <van-icon name="arrow-left" size="20" color="#333" @click="goBack" />
      <span class="history-header-title">{{ $t('history_chats') }}</span>
      <span style="width: 20px;"></span>
    </div>

    <!-- Chat Session 列表 -->
    <div class="history-content">
      <ChatSession />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon } from 'vant'

Vue.use(Icon)

import ChatSession from './ChatSession'

export default {
  name: 'HistoryPage',
  components: {
    'ChatSession': ChatSession
  },
  methods: {
    goBack() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.history-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #F7F5F2;
}

.history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: white;
  border-bottom: 1px solid #E0DDD8;
  flex-shrink: 0;
}

.history-header-title {
  font-size: 16px;
  font-weight: 600;
  color: #1A1A1A;
}

.history-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/HistoryPage.vue